import type { FC, ReactNode } from 'preact/compat';
import { useEffect } from 'preact/compat';

import { useVkCaptchaContext } from '../../context/VkCaptchaContext';
import { useWidget } from '../../context/WidgetContext';
import { useStompTokenAutoRefresh } from '../../hooks/useStompTokenAutoRefresh';
import { tokenManager, websocketConnectionManager } from '../../utils';
import { useStompClient } from 'react-stomp-hooks';

interface Props {
  children: ReactNode;
}

const TOKEN_CHECK_MS = 5000;

const WebSocketWrapperChildren: FC<Props> = ({ children }) => {
  useStompTokenAutoRefresh();
  const stompClient = useStompClient();
  const { widgetUuid } = useWidget();
  const { setIsCaptchaPassed } = useVkCaptchaContext();

  useEffect(() => {
    const timerId = setInterval(() => {
      if (tokenManager.getToken() && tokenManager.getIsTokenExpired()) {
        void tokenManager.refreshToken(widgetUuid);
        setIsCaptchaPassed?.(false);
      }
    }, TOKEN_CHECK_MS);

    return () => clearInterval(timerId);
  }, [setIsCaptchaPassed, widgetUuid]);

  useEffect(() => {
    if (stompClient) {
      websocketConnectionManager.setCurrentClient(stompClient);
    }
  }, [stompClient]);

  return children;
};

export { WebSocketWrapperChildren };
